export const BOT_NAME = "Human_Design_Online_bot";
export const REQUIRE_FIELD_HELP_TEXT = "Это обязательное поле";
